<template>
  <div id="app">
    <!-- Legacy header (NOT shown inside /portal/*) -->
    <header class="appbar" v-if="showLegacyIncentivesHeader">
      <router-link to="/" class="brand" aria-label="Edda Home – CRM">
        <img :src="logoUrl" alt="Edda Home" class="logo" />
        <span class="brand-text">CRM</span>
      </router-link>

      <nav v-if="isAuth" class="nav">
        <router-link :to="{ name: portalHomeName }">🏠 Portal</router-link>
        <router-link v-if="currentUser && currentUser.role==='admin'"
                 :to="{ name: 'admin' }">Incentives Admin</router-link>
        <router-link :to="{ name: 'incentives-dashboard' }">Dashboard</router-link>
        <router-link :to="{ name: 'incentives-sales-new' }">Add Sale</router-link>
        <router-link :to="{ name: 'incentives-rewards' }">Rewards</router-link>
        <router-link v-if="isManager" to="/branch/expenses">Branch Expenses</router-link>
        <button class="link" @click="doLogout">Logout</button>
      </nav>
    </header>

    <!-- Everything under /portal/* renders its own header inside Portal.vue -->
    <main class="content">
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      logoUrl: require('@/assets/final_logo.jpeg')
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'currentUser']),
    isAuth(){ return this.isAuthenticated },
    isManager(){ return this.currentUser && this.currentUser.role === 'branch_manager' },
    showLegacyIncentivesHeader () {
      var n = this.$route && this.$route.name
      var p = (this.$route && this.$route.path) || ''
      // hide on /portal/* and on the login page
      return !p.startsWith('/portal') && n !== 'login'
    },
    portalHomeName () {
      return 'sales-dashboard'
    }

  },
  methods: {
    doLogout(){
      this.$store.dispatch('auth/logout')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss">
/* ==== Light theme baseline (applies to legacy Incentives) ==== */
:root{
  --bg:#f7f8fb;
  --surface:#ffffff;
  --ink:#111827;
  --muted:#6b7280;
  --border:#e5e7eb;
  --border-soft:#f1f5f9;
  --brand:#ef4444;       /* Edda red underline */
  --accent:#ef4444;
}

*{ box-sizing:border-box }
html, body, #app{
  height:100%;
  margin:0;
  background:var(--bg);
  color:var(--ink);
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}

html, body {
  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}


/* Header for legacy Incentives (Portal has its own header) */
.appbar{
  display:flex; align-items:center; justify-content:space-between;
  padding:12px 20px;
  background:#ffffff;
  position:sticky; top:0; z-index:10;
  border-bottom:1px solid var(--border);
  box-shadow: inset 0 -2px 0 var(--brand);  /* brand underline */
}

/* Brand */
.brand{ display:flex; align-items:center; gap:12px; font-weight:700; color:var(--ink); text-decoration:none; }
.logo{ height:40px; width:auto; object-fit:contain; display:block; border-radius:8px; }
.brand-text{ opacity:.95; letter-spacing:.2px }

/* Nav */
.nav{ display:flex; gap:16px; align-items:center }
.nav a{
  color:#334155; text-decoration:none; padding:6px 8px; border-radius:8px;
}
.nav a.router-link-exact-active{ background:#fee2e2; color:#991b1b }
.nav .link{ background:transparent; border:0; color:#b91c1c; cursor:pointer }

/* Content + shared utilities (kept API-compatible with your legacy pages) */
.content{ padding:20px; max-width:1100px; margin:0 auto }
.card{
  background:var(--surface);
  border:1px solid var(--border);
  border-radius:14px;
  padding:16px;
  box-shadow: 0 1px 2px rgba(16,24,40,.04);
}
.row{ display:flex; gap:16px; flex-wrap:wrap }
.col{ flex:1 1 320px }

/* <- THIS is the important change: light inputs everywhere in Incentives */
.input,
input.input,
select.input,
textarea.input,
select{
  width:100%;
  padding:10px 12px;
  border-radius:10px;
  border:1px solid var(--border);
  background:#ffffff;
  color:var(--ink);
  height:40px;
  outline:none;
}
.input:focus,
input.input:focus,
select.input:focus,
textarea.input:focus,
select:focus{
  border-color:#fca5a5;
  box-shadow:0 0 0 3px rgba(239,68,68,.12);
}

.btn{
  background:var(--accent);
  color:#fff;
  border:0;
  padding:10px 16px;
  border-radius:10px;
  cursor:pointer; font-weight:600;
}
.btn.secondary{ background:#f3f4f6; color:#111827; border:1px solid var(--border) }

.helper{ color:var(--muted); font-size:12px }

.table{ width:100%; border-collapse:collapse }
.table th,.table td{ border-bottom:1px solid var(--border-soft); padding:10px; text-align:left }

.kpi{ font-size:22px; font-weight:700 }
.mono{ font-family: ui-monospace, SFMono-Regular, Menlo, monospace }
.badge{ padding:4px 8px; border-radius:8px; background:#fee2e2; font-size:12px; color:#991b1b }

.warn{ color:#b45309 }
.error{ color:#b91c1c }

@media (max-width: 420px){ .logo{ height:36px } }
</style>

